import { z } from 'zod';
import { DevDocumentStatusFilterSchema } from '@/features/stacktrace/dev-documents/-constants';
import { DevDocumentKind, DevDocumentStatus } from '@/features/stacktrace/dev-documents/-query/type';
import { DevDocumentTableColumns } from './-table/type';

/**
 * 開発ドキュメント台帳 一覧画面の URL search スキーマ。
 *
 * - status:         ステータスタブ用フィルタ（"ALL" + 5 ドメイン値。既定は稼働中）
 * - productId:      プロダクト絞り込み（単一 ID）
 * - kind:           種別絞り込み（単一値）
 * - freeText:       検索バー（BE は title / code / summary / triggerDescription が対象）
 * - pageIndex:      0-origin ページ番号
 * - pageSize:       1 ページあたりの件数
 * - sortColumn:     ソート対象カラム
 * - orderDirection: ソート方向
 *
 * 出自（ownership）と同期状態（syncState）の絞り込みは画面から外した。
 * BE のクエリパラメータは残っているので、必要になれば戻せる。
 */
export const DevDocumentListPageFilterSchema = z.object({
  status: DevDocumentStatusFilterSchema.default(DevDocumentStatus.ACTIVE),
  productId: z.string().optional(),
  kind: z.nativeEnum(DevDocumentKind).optional(),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(DevDocumentTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('desc')
});